import { api, setToken, clearToken, getToken } from "./api";

export interface AuthUser {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  phone: string | null;
  avatar: string | null;
  role: string;
  role_name: string;
}

export interface LoginResponse {
  token: string;
  user: AuthUser;
}

export async function login(email: string, password: string): Promise<LoginResponse> {
  const data = await api.post<LoginResponse>("/auth/login", { email, password });
  setToken(data.token);
  return data;
}

export async function fetchMe(): Promise<AuthUser> {
  return api.get<AuthUser>("/auth/me");
}

/**
 * Sign out: revoke the current session on the backend, then clear the local
 * token. Best-effort on the network call — the token is always cleared locally.
 */
export async function logout(): Promise<void> {
  try {
    if (getToken()) {
      await api.post("/auth/logout");
    }
  } catch {
    // best-effort: still clear the local token
  } finally {
    clearToken();
  }
}

/**
 * Revoke every session for this user on the backend, then clear the local token.
 */
export async function logoutAll(): Promise<void> {
  try {
    if (getToken()) {
      await api.post("/auth/logout-all");
    }
  } finally {
    clearToken();
  }
}

export function isAuthenticated(): boolean {
  return Boolean(getToken());
}